import { render, staticRenderFns } from "./privacy-control.vue?vue&type=template&id=3305f239&scoped=true"
import script from "./privacy-control.vue?vue&type=script&lang=js"
export * from "./privacy-control.vue?vue&type=script&lang=js"
import style0 from "./privacy-control.vue?vue&type=style&index=0&id=3305f239&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3305f239",
  null
  
)

export default component.exports